var _style, _g, _g2, _path, _g3, _rect, _path2, _path3, _rect2, _rect3, _rect4, _path4, _path5, _path6, _circle, _defs, _g4, _polygon, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#D3D3D3;stroke-miterlimit:10;stroke-dasharray:12.2456,12.2456;}\r\n\t.st1{fill:#F7F7F7;}\r\n\t.st2{fill:#F2F2F2;}\r\n\t.st3{fill:#2A94F4;}\r\n\t.st4{fill:#CCE9FF;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;stroke:#CCE9FF;stroke-miterlimit:10;}\r\n\t.st7{clip-path:url(#SVGID_2_);}\r\n\t.st8{fill:#0B4870;}\r\n\t.st9{fill:#FCD2B1;}\r\n\t.st10{fill:#FFE3CA;}\r\n\t.st11{fill:#FFBE55;}\r\n\t.st12{fill:#0D4972;}\r\n\t.st13{fill:#0E538C;}\r\n\t.st14{fill:#1A87D8;}\r\n\t.st15{fill:#B0E1FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 844.75,
    cy: 197.25,
    r: 85.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.28,193.61c-25.74,11.26-51.33,24.98-69.34,46.55s-27.03,52.56-16.23,78.5   c14.43,34.65,60.15,54.8,60.36,92.33c0.15,26.88-24.66,47.41-49.7,57.18s-52.76,13.29-75.54,27.58   c-34.37,21.55-50.48,63.27-57.08,103.3c-6.85,41.56-4.07,88.88,25.34,119.03c36.55,37.48,97,33.25,148.74,25.26   c69.05-10.66,137.79-23.19,206.52-35.72c150.67-27.46,301.34-54.93,452.01-82.39c16.16-2.95,32.96-6.17,46.09-16.03   c26.07-19.6,28.27-60.05,13.12-88.93c-15.15-28.88-43.18-48.5-71.02-65.48c-27.84-16.98-57.24-33.04-78.09-58.11   s-31.22-62.19-15.44-90.73c13.37-24.18,42.09-37.1,54.61-61.73c16.5-32.45-2.49-73.89-32.42-94.61   C820.27,128.89,444.29,134.14,308.28,193.61z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1003.94,1027.61H96.06c-6.08,0-11.06-4.98-11.06-11.06v-57.5c0-6.08,4.98-11.06,11.06-11.06h907.89  c6.08,0,11.06,4.98,11.06,11.06v57.5C1015,1022.63,1010.02,1027.61,1003.94,1027.61z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 782,
    className: "st3",
    width: 200,
    height: 135
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.65,389h664.71c13.61,0,24.65,11.03,24.65,24.65v398.71c0,13.61-11.03,24.65-24.65,24.65H217.65   c-13.61,0-24.65-11.03-24.65-24.65V413.65C193,400.03,204.03,389,217.65,389z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.34,
    y: 408,
    className: "st5",
    width: 675.31,
    height: 410
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M396,911h288c20.43,0,37,16.57,37,37v0H359v0C359,927.57,375.57,911,396,911z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 442,
    className: "st4",
    width: 113,
    height: 113
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M865,582H433c-4.97,0-9-4.03-9-9l0,0c0-4.97,4.03-9,9-9h432c4.97,0,9,4.03,9,9l0,0  C874,577.97,869.97,582,865,582z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563,610H433c-4.97,0-9-4.03-9-9l0,0c0-4.97,4.03-9,9-9h130c4.97,0,9,4.03,9,9l0,0  C572,605.97,567.97,610,563,610z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 564,
    className: "st4",
    width: 56,
    height: 56
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 442,
    className: "st1",
    width: 515,
    height: 113
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 564,
    className: "st2",
    width: 113,
    height: 237
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M855.21,701H377.79c-10.38,0-18.79-8.41-18.79-18.79v-21.43c0-10.38,8.41-18.79,18.79-18.79h477.43  c10.38,0,18.79,8.41,18.79,18.79v21.43C874,692.59,865.59,701,855.21,701z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M701.78,800.5H378.72c-10.62,0-19.22-8.61-19.22-19.22v-49.55c0-10.62,8.61-19.22,19.22-19.22h323.05  c10.62,0,19.22,8.61,19.22,19.22v49.55C721,791.89,712.39,800.5,701.78,800.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M862.95,801h-117.9c-6.65,0-12.05-5.39-12.05-12.05v-63.9c0-6.65,5.39-12.05,12.05-12.05h117.9  c6.65,0,12.05,5.39,12.05,12.05v63.9C875,795.61,869.61,801,862.95,801z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 294,
    cy: 283,
    r: 111
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 294,
    cy: 283,
    r: 111
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M286.06,192.93c16.79-10.06,44.99,2.17,58.69,30.61c13.51,28.05,9.09,65.39,26.34,90.55        c7.45,10.86,19.05,20.1,19.3,33.96c0.19,10.5-6.92,19.76-15.3,23.81c-8.38,4.06-17.8,3.92-26.86,3.15        c-34.65-2.92-70.08-14.96-95.34-42.53c-25.27-27.57-37.78-72.98-23.56-109.62c4.8-12.36,12.61-23.48,23.01-29.7        c10.41-6.23,23.53-6.99,33.72-0.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M281.49,326.19c-12.92,0-69.43,11.3-68.62,54.09c20.18,11.3,65.45,23.13,93.64,19.37       c24.22-3.23,67.81-26.64,67.81-26.64s-22.6-51.67-72.65-46.82C292.79,346.37,281.49,326.19,281.49,326.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M279.13,303.67c0,0,0,28.78-5.6,32.53c16.17,10.64,22.39,15.01,22.39,15.01l18.66-13.76       c-4.35-6.88-9.33-23.15-8.09-36.91C292.19,302.42,279.13,303.67,279.13,303.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M339.1,249.57c0,27.13-20.73,63.49-46.3,63.49c-25.57,0-46.3-36.36-46.3-63.49s20.73-49.12,46.3-49.12       C318.37,200.44,339.1,222.44,339.1,249.57z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M269.29,207.72c0.71,17.37,12.91,32.63,27.75,41.68c14.84,9.05,32.16,12.99,49.13,16.78        c-3.15-14.78-6.51-29.79-14.01-42.91c-7.5-13.11-19.89-24.27-34.82-26.59c-8.86-1.37-17.94,0.43-26.4,3.37        c-8.15,2.84-16.23,6.98-21.39,13.9c-8.87,11.9-6.92,28.38-4.56,43.03c9.72-11.68,21.84-21.36,35.38-28.26"
  })))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "276,424 279.37,376.45 240,377   "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 386.5,
    cy: 348.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.24,343.77h10.27v-11.59c0-2.63,2.14-4.77,4.77-4.77h0.44c2.63,0,4.77,2.14,4.77,4.77v11.59h10.27     c2.63,0,4.77,2.14,4.77,4.77l0,0c0,2.63-2.14,4.77-4.77,4.77h-10.27v11.52c0,2.63-2.14,4.77-4.77,4.77h-0.44     c-2.63,0-4.77-2.14-4.77-4.77v-11.52h-10.27c-2.63,0-4.77-2.14-4.77-4.77l0,0C366.47,345.9,368.6,343.77,371.24,343.77z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M397,422l2-14c0,0,3-8,3-11s-1-7-3-7c-1-12-2-20-2-20s-2,0-3,2s0,9,0,9s-12,8-12,11s6,20,6,20l-1,14L397,422z   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M588.11,681.44l6.05,11.09c0,0,12.1,8.07,12.1,12.1c0,4.03,0,9.07,0,9.07l-9.07,11.09   c0,0-8.06-22.18-9.07-21.17c-1.01,5.04-1.01,11.09-3.02,12.1c-1.01-6.05,2.02-21.17-2.02-26.21   C579.04,684.46,588.11,681.44,588.11,681.44z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.05,
    y: 921.52,
    transform: "matrix(-0.9969 0.0783 -0.0783 -0.9969 1234.11 1834.0034)",
    className: "st10",
    width: 18.15,
    height: 39.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M591.7,960.07c7.67,7.49,13.16,13.12,13.48,17.14c-6.64,5.58-28.44,11.33-38.96,6.09   c-2.11-13.99,7.39-21.82,7.39-21.82L591.7,960.07z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.11,
    y: 921.37,
    transform: "matrix(-1 -4.490775e-11 4.490775e-11 -1 946.3716 1882.0588)",
    className: "st10",
    width: 18.15,
    height: 39.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M475.71,638.59c-12.1,37.3-58.47,189.53-19.15,299.41c16.63,11.59,34.78,0.5,34.78,0.5   s40.83-161.8,29.74-227.33c-11.09-65.53-12.6-72.58-12.6-72.58H475.71z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.37,
    y: 489.39,
    transform: "matrix(-1 -4.485935e-11 4.485935e-11 -1 1007.3632 1010.0311)",
    className: "st10",
    width: 14.62,
    height: 31.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M478.86,481.74c0,14.84,5.69,26.88,17.65,26.88c11.96,0,25.67-12.03,25.67-26.88   c0-14.84-9.7-26.88-21.66-26.88S478.86,466.9,478.86,481.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M483.27,455.26c3.21,12.84,5.62,42.52,23.27,52.95c11.23,5.62,44.13-24.07,28.08-50.55   S484.87,448.04,483.27,455.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M510.99,520.64c18.15,2.02,44.36,15.12,44.36,15.12s30.24,114.93,36.29,150.21c-9.07,6.05-12.1,9.07-12.1,9.07   l-34.28-112.91l-13.11,56.45h-56.45l-13.11-72.58c0,0-84.68-41.33-77.63-143.15c16.13-7.06,16.13-7.06,16.13-7.06   s-4.03,107.87,74.6,105.85C475.71,521.65,500.91,516.61,510.99,520.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M532.04,638.59c35.28,61.5,79.64,217.75,63.51,303.45c-16.63,13.61-30.24,0-30.24,0   s-60.49-132.06-59.48-226.83c-4.03-56.45-0.01-76.62-0.01-76.62H532.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M482.26,960.69c7.06,8.07,12.1,14.11,12.1,18.15c-7.06,5.04-29.24,9.07-39.32,3.02   c-1.01-14.11,9.07-21.17,9.07-21.17H482.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M535,458c6,12,19,48,37,43c-26,24-77,22-90,17c8-24,6.1-45.92,6.1-45.92L535,458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M487,451c-3,2-11,12-10,14s19,11,19,11L487,451z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M147.98,919.81c-6.79-31.67-27.72-60.03-55.98-75.86c15.12,28.55,33.22,55.53,53.91,80.34L147.98,919.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.56,931.71c-26.93-37.65-40.43-84.7-37.56-130.89c17.45,42.64,30.63,87.03,39.28,132.28L155.56,931.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M147.85,933c-0.82-23.16-1.64-46.5,2-69.39c3.63-22.89,12.05-45.58,27.62-62.75     c2.37,47.42-9.1,95.45-32.65,136.67L147.85,933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.96,935.06c-15.16-43.8-12.68-93.43,6.78-135.49c12.16,43.95,1.4,90.6-9.37,134.91L148.96,935.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.97,918.84c4.19-38.42,29.82-73.78,65.03-89.71c-14.29,38.33-38.7,72.84-70.1,99.06L150.97,918.84z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.24,912.11l-4.36,74.61c0,3.59-2.94,6.54-6.54,6.54h-51.74c-3.59,0-6.54-2.94-6.54-6.54l-0.99-16.87   l-3.37-57.75c0-3.59,2.94-6.54,6.54-6.54h60.45c2.36,0,4.44,1.27,5.59,3.15v0.01C186.89,909.72,187.24,910.88,187.24,912.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.24,912.11l-4.36,74.61c0,3.59-2.94,6.54-6.54,6.54h-51.74c-3.59,0-6.54-2.94-6.54-6.54l-0.99-16.87    c24.13-6.9,49.02-36.74,69.21-61.12C186.89,909.72,187.24,910.88,187.24,912.11z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M945.44,891.91c-9.37-43.7-38.25-82.84-77.24-104.68c20.86,39.4,45.83,76.62,74.38,110.86L945.44,891.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M955.89,908.33c-37.15-51.95-55.78-116.87-51.83-180.62c24.08,58.84,42.27,120.09,54.2,182.53L955.89,908.33     z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M945.27,910.11c-1.14-31.96-2.26-64.16,2.75-95.74c5.01-31.58,16.63-62.89,38.11-86.58     c3.27,65.43-12.56,131.7-45.05,188.59L945.27,910.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M946.79,912.96c-20.92-60.43-17.49-128.91,9.36-186.96c16.78,60.64,1.93,125.01-12.93,186.15L946.79,912.96     z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M949.56,890.58c5.78-53.01,41.15-101.81,89.74-123.79c-19.71,52.89-53.41,100.51-96.73,136.69L949.56,890.58     z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M999.62,881.29l-6.01,102.96c0,4.96-4.06,9.02-9.02,9.02h-71.39c-4.96,0-9.02-4.06-9.02-9.02l-1.36-23.27   l-4.65-79.68c0-4.96,4.06-9.02,9.02-9.02h83.42c3.25,0,6.12,1.75,7.71,4.35v0.01C999.14,877.99,999.62,879.59,999.62,881.29z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M999.62,881.29l-6.01,102.96c0,4.96-4.06,9.02-9.02,9.02h-71.39c-4.96,0-9.02-4.06-9.02-9.02l-1.36-23.27    c33.29-9.52,67.64-50.69,95.5-84.34C999.14,877.99,999.62,879.59,999.62,881.29z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.579047027071254f813e7adf4c31410f.svg";
export { ForwardRef as ReactComponent };